var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconPaperCode(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2002 7.19844H20.0002L15.2002 2.39844V7.19844Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1998 8.79852C14.3162 8.79852 13.6 8.0814 13.6 7.19844V2.39844H5.59984C4.71616 2.39844 4 3.11388 4 3.99852V19.9984C4 20.8813 4.71616 21.5984 5.59984 21.5984H18.4C19.2827 21.5984 19.9998 20.883 19.9998 19.9984V8.79852H15.1998ZM10.3998 12.3985H9.59992C9.37888 12.3985 9.19984 12.5773 9.19984 12.7984V17.5984C9.19984 17.8187 9.37888 17.9984 9.59992 17.9984H10.3998V19.1984H9.59992C8.71624 19.1984 7.99984 18.4813 7.99984 17.5984V12.7984C7.99984 11.9147 8.71624 11.1985 9.59992 11.1985H10.3998V12.3985ZM16 17.5984C16 18.482 15.2829 19.1984 14.3999 19.1984H13.6V17.9984H14.3999C14.6202 17.9984 14.8 17.8196 14.8 17.5984V12.7984C14.8 12.578 14.6202 12.3985 14.3999 12.3985H13.6V11.1985H14.3999C15.2829 11.1985 16 11.9156 16 12.7984V17.5984Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPaperCode);
export default __webpack_public_path__ + "static/media/icon-paper-code.6cf7e01b4dc70727213bfcef0eaf50e1.svg";
export { ForwardRef as ReactComponent };